<div class="ecb-customer-page">
  <aside class="portal-sidebar">
    <a routerLink="/" class="ecb-logo mb-4"><span class="ecb-logo-mark">ECB</span><span
        class="ecb-logo-text"><span>Student</span><small>TRAINING PORTAL</small></span></a>
    <a routerLink="/customer/dashboard" routerLinkActive="active"><i class="fa fa-dashboard"></i>Dashboard</a>
    <a routerLink="/customer/purchases" routerLinkActive="active"><i class="fa fa-shopping-bag"></i>My Purchases</a>
    <a routerLink="/customer/profile" routerLinkActive="active"><i class="fa fa-user"></i>Profile</a>
    <a routerLink="/course-qualifications"><i class="fa fa-graduation-cap"></i>Book Course</a>
  </aside>
  <main class="portal-content"><router-outlet></router-outlet></main>
</div>